<template>
  <div class="bg-white rounded-3xl p-4 shadow-sm">
    <div class="mb-3 flex items-start justify-between">
      <div>
        <h3 class="text-base font-semibold text-primary-dark-text">
          {{ title }}
        </h3>
        <p v-if="subtitle" class="text-xs text-neutral-light mt-1">
          {{ subtitle }}
        </p>
      </div>
      <slot name="actions"></slot>
    </div>

    <template v-if="hasData">
      <ApexChart
        type="donut"
        :options="chartOptions"
        :series="series"
        height="200"
      />
    </template>
    <template v-else>
      <div
        class="flex h-[200px] flex-col items-center justify-center gap-1.5 text-center text-xs text-neutral-light"
      >
        <svg
          class="h-8 w-8 text-neutral-light/60"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h6" />
          <path d="M15 12h6" />
        </svg>
        <p class="font-medium text-primary-dark-text">No usage activity yet</p>
        <p>
          We will show how polls and spaces perform once they become active.
        </p>
      </div>
    </template>
  </div>
</template>

<script setup>
/* global defineProps */
import { computed } from "vue";
import ApexChart from "vue3-apexcharts";

// eslint-disable-next-line no-undef
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: "",
  },
  series: {
    type: Array,
    required: true,
  },
  labels: {
    type: Array,
    required: true,
  },
  colors: {
    type: Array,
    default: () => ["#AF56FE", "#43BFE0", "#E5E7EB"],
  },
  centerLabel: {
    type: String,
    default: "",
  },
});

const hasData = computed(
  () => Array.isArray(props.series) && props.series.some((value) => value > 0)
);

const chartOptions = computed(() => ({
  chart: {
    type: "donut",
  },
  labels: props.labels,
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "left",
    itemMargin: {
      horizontal: 12,
      vertical: 4,
    },
    markers: {
      radius: 12,
    },
  },
  stroke: {
    width: 0,
  },
  plotOptions: {
    pie: {
      donut: {
        size: "55%",
        background: "transparent",
        labels: {
          show: true,
          name: {
            show: false,
          },
          value: {
            show: false,
          },
          total: {
            show: !!props.centerLabel,
            label: props.centerLabel,
            showAlways: true,
            formatter: () => props.centerLabel,
          },
        },
      },
    },
  },
  colors: props.colors,
  states: {
    hover: {
      filter: {
        type: "lighten",
        value: 0.05,
      },
    },
    active: {
      filter: {
        type: "none",
      },
    },
  },
  responsive: [
    {
      breakpoint: 640,
      options: {
        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },
      },
    },
  ],
}));
</script>
